"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.radiusProp = void 0;
const theme_props_js_1 = require("./theme.props.js");
const radiusProp = {
    type: 'enum',
    values: theme_props_js_1.themePropDefs.radius.values,
    default: undefined,
};
exports.radiusProp = radiusProp;
//# sourceMappingURL=radius.prop.js.map